import { render, staticRenderFns } from "./CBAG1030.vue?vue&type=template&id=6eda53c6&scoped=true"
import script from "./CBAG1030Controller.ts?vue&type=script&lang=ts&external"
export * from "./CBAG1030Controller.ts?vue&type=script&lang=ts&external"
import style0 from "./CBAG1030.vue?vue&type=style&index=0&id=6eda53c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eda53c6",
  null
  
)

export default component.exports